import { uploadData } from "aws-amplify/storage";
import { Project, SyncConfig, User, UserForResolver } from "db/definitions";
import { downloadFormGroupJson } from "db/merge";

async function handleProjectBackup(project: Project, user: UserForResolver, online: boolean) {
	// first get the full project with all of its children
	try {
		const syncConfig: SyncConfig = {
			online,
			source: online ? "remote" : "local",
			destination: "json",
		};
		// Need to get a list of all the form group ids in a project.
		const formGroupIds = project.formGroups.items.map((formGroup) => formGroup.id);
		const json = await downloadFormGroupJson(project, formGroupIds, syncConfig);
		// Next JSON ify
		const stringifiedJson = JSON.stringify(json);

		// Create download anchor + download
		const date = new Date();
		const year = date.getFullYear().toString().slice(-2); // Last 2 digits of the year
		const month = (date.getMonth() + 1).toString().padStart(2, "0"); // The month with a leading zero if less than 2 characters
		const day = date.getDate().toString().padStart(2, "0"); // The day with a leading 0 if it's less than 2 characters
		const hour = date.getHours().toString().padStart(2, "0"); // The hour with a leading 0 if less than 2 characters
		const minute = date.getMinutes().toString().padStart(2, "0"); // The minutes with a leading 0 if less than 2 characters
		const seconds = date.getSeconds().toString().padStart(2, "0"); // The seconds with a leading 0 if less than 2 characters
		const finalTime = `${hour}${minute}${seconds} ${month}-${day}-${year}`;
		// downloadAnchorNode.setAttribute("download", `${finalTime}|${project.name}|${user?.username || "UnknownUser"}.json`);
		const url = `${user?.group}/delete-backups/${project.name}/${user?.username || "UnknownUser"}-${finalTime}.json`;
		await uploadData({
			key: url,
			data: stringifiedJson,
		}).result;

		// true for success I guess....
		return true;
	} catch (error) {
		console.error("Error handling project backup:", error);
		throw new Error(`Failed to backup project before deletion: ${error}`);
	}
}

export default handleProjectBackup;
